module.exports = __webpack_public_path__ + "img/cloud-arrow-down-fill.a4ffddd7.svg";